import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/global/Layout"
import Seo from "../components/global/SEO"
import Nav from "../components/global/Nav"
import ParticleHeader from "../components/blocks/ParticleHeader"
import BackArrow from "../components/blocks/BackArrow"
import Footer from "../components/global/Footer"
import { withPreview } from "gatsby-source-prismic"

import styled from "@emotion/styled"

const Outer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  row-gap: 32px;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  padding: 32px 0;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#ffffff"};
`
const Inner = styled.div`
  width: 100%;
  grid-column: 2;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    * {
      word-break: break-word;
    }
  }
`
const Content = styled.article``

const BlogPost = ({ data }) => {
  return (
    <Layout>
      <Seo title={data.prismicPost.data.title.text} />
      <Nav />
      <ParticleHeader post={true}>
        {data.prismicPost.data.title.text}
      </ParticleHeader>
      <Outer>
        <Inner>
          <BackArrow />
          <Content
            dangerouslySetInnerHTML={{
              __html: data.prismicPost.data.content.html,
            }}
          ></Content>
        </Inner>
      </Outer>
      <Footer />
    </Layout>
  )
}

export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    prismicPost(uid: { eq: $uid }) {
      data {
        title {
          text
        }
        content {
          html
        }
      }
    }
  }
`
export default withPreview(BlogPost)
